import { GoToSessionButton } from './GoToSessionButton'
import { ArchiveCallingSessionButton } from './ArchiveCallingSessionButton'

type CallingSessionActionsProps = {
  session: {
    id: string
    name: string | null
  }
}

export function CallingSessionActions({ session }: CallingSessionActionsProps) {
  return (
    <div className="tw:flex tw:justify-end tw:gap-2">
      <GoToSessionButton session={session} />
      <ArchiveCallingSessionButton session={session} />
    </div>
  )
}
